import { styled } from "@mui/material/styles";
import { Box, Stack, Button } from "@mui/material";

// TODO: delete this deprecated code and use Base components
import { TextField } from "@components/base";

export const ResetPasswordBox = styled(Box)({
  marginTop: 24,
  padding: 24,
  borderRadius: 8,
  boxShadow:
    "0px 1px 3px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
  backgroundColor: "#fff",
});

export const ResetPasswordStack = styled(Stack)({
  marginTop: 24,
  marginBottom: 24,
});

export const PasswordTextField = styled(TextField)<{ match?: boolean }>(
  ({ match }) => ({
    maxWidth: 600,
    flexGrow: 1,
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: match === undefined ? "" : match ? "green" : "red",
      },
      "&:hover fieldset": {
        borderColor: match === undefined ? "" : match ? "green" : "red",
      },
      "&.Mui-focused fieldset": {
        borderColor: match === undefined ? "" : match ? "green" : "red",
      },
    },
    "& .MuiInputLabel-root": {
      color: match === undefined ? "" : match ? "green" : "red",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: match === undefined ? "" : match ? "green" : "red",
    },
  }),
);

export const PasswordButton = styled(Button)({
  width: "5rem",
  height: "2.5rem",
});
